import { useMutation } from "@apollo/client";
import { Spinner, Toast } from "@aurem/ui";
import { emailVerificationParams } from "const/routes";
import { useI18n } from "providers/I18nProvider";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { gql } from "types";

export const VERIFY_EMAIL = gql(/* GraphQL */ `
  mutation VerifyEmail($verificationId: String!) {
    verifyEmail(verificationId: $verificationId) {
      email
    }
  }
`);

const EmailVerificationPage = () => {
  const { verificationId } =
    useParams<emailVerificationParams>() as emailVerificationParams;
  const navigate = useNavigate();
  const [verifyEmail] = useMutation(VERIFY_EMAIL);
  const { t } = useI18n();
  const handleVerification = async () => {
    try {
      const { data } = await verifyEmail({
        variables: { verificationId },
      });
      if (data?.verifyEmail?.email) {
        Toast.success({
          title: t(
            "apps.admin.pages.emailVerification.verificationId.page.verification.success",
            data?.verifyEmail.email,
          ),
        });
        await navigate("/");
      }
    } catch (e) {
      Toast.error({
        title: t(
          "apps.admin.pages.emailVerification.verificationId.page.verification.failure",
        ),
      });
    }
  };

  useEffect(() => {
    void handleVerification();
  }, []);

  return <Spinner size="sm" />;
};

export default EmailVerificationPage;
